/* unplugin-vue-components disabled */import script from "./right-chat.vue?vue&type=script&lang=ts&setup=true"
export * from "./right-chat.vue?vue&type=script&lang=ts&setup=true"

import "./right-chat.vue?vue&type=style&index=0&id=05661388&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05661388"]])

export default __exports__